import React from 'react';
import Script from "next/script"
import DOMPurify from 'isomorphic-dompurify';

class SEOArticle extends React.PureComponent {
  render() {
    const props = this.props;
    let { articleData, articleUrl, locale } = props;
    var seoConfig = require('../../../data/' + locale + '/seo.json');
    return (
      <>
        <Script
          id='seo-article'
          type='application/ld+json'
          strategy='afterInteractive'
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( `
            { 
                "@context": "${seoConfig.context}", 
                "@type": "Article", 
                "author": "Pantene Brazil",
                "datePublished": "07-01-2020",
                "dateModified": "07-01-2020", 
                "mainEntityOfPage":{
                  "@type": "Webpage",
                  "@id": "${articleUrl}"
                },
                "headline": "${articleData.name}",
                "image": {
                  "@type": "ImageObject",
                  "url": "${articleData.heroImage && articleData.heroImage.url}"
                },
                "publisher": {
                  "@type": "Organization",
                  "name": "Pantene Brazil",
                  "url": "https://pantene.com.br/pt-br",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "https://images.ctfassets.net/bwmjeuu0n1om/6DMYWHJQhJyKtEeJ19axtf/e88410218fdfdf456904ac15f236bf33/Image_2_3x.png"
                  },
                  "description": "${articleData.name}"
                }
            }`),
          }}
        />
      </>
    );
  }
}

export default SEOArticle;
